import { buildStandaloneSearchBox, buildTab, buildSearchEngine } from '@coveo/headless'
import { SearchIcon } from '../../svg-elements/search-icon-new'
import { CloseIcon } from '../../svg-elements/close-icon'
import store from '@/store'
import {
    applyConsentToHeadlessEngine,
    consentNavigatorContextProvider,
    headlessAnalyticsConfig
} from '@platform/utils/coveoConsent'
import CoveoComponent from '../../../../ui/coveoComponent/CoveoComponent.vue'
import CoveoAILoggedIn from '../../../blocks/coveo-ai-logged-in/CoveoAILoggedIn.vue'

const SearchBox = {
    extends: CoveoComponent,
    template: `
        <div id="searchbox-headless" class="search-box" v-if="searchEngine">
            <div class="searchbox_container" role="search">
                <input
                    v-model="q"
                    @keydown.enter="submit($event)"
                    @keydown="selectSuggestion($event)"
                    @focus="displaySuggestions"
                    @focusout="hideSuggestions"
                    @change="(e) => updateText(e.target.value)"
                    class="searchbox_input"
                    :placeholder="placeholderText"
                    :aria-label="searchLabel"/>
                <CloseIcon v-if="q.length" class="search__close" tabindex="0" type="button" aria-label="clear search" @click="clearSearchTerm"></CloseIcon>
                <div v-if="q.length" class="divider"></div>
                <CoveoAILoggedIn v-if="displayCoveoIcon"></CoveoAILoggedIn>
                <SearchIcon class="search__icon" tabindex="0" type="button" aria-label="submit search" @click.native="submit($event)"></SearchIcon>
            </div>
            <ul v-if="state && state.suggestions.length > 0 && showSuggestions" class="suggestion_list" :class="suggestionClass">
                <li v-for="(suggestion, index) in state.suggestions"
                    :key="index"
                    class="suggestion"
                    :id="'suggestion' + index"
                    tabindex="0"
                    @click="submit($event, suggestion.rawValue)"
                    @keyup.enter="submit($event,suggestion.rawValue)"
                    v-html="suggestion.highlightedValue">
                </li>
            </ul>
        </div>
  `,
    name: 'SearchBox',
    // store: store,
    props: {
        isGlobalSearch: { Type: String, default: 'true' },
        parentAuthorableElementId: { Type: String, default: '' },
        activeTab: { Type: String, default: '' },
        altPlaceholderText: { Type: String, default: '' },
        displayCoveoIcon: { Type: Boolean, default: false }
    },
    data: function () {
        return {
            selectedSearchValue: null,
            q: '',
            suggestionIndex: -1,
            showSuggestions: false,
            authorableAemFields: '',
            count: 0,
            searchBoxController: null,
            engineKey: 'DowComMainSearch',
            allTabController: {},
            corporateEngine: null
        }
    },
    components: {
        SearchIcon: SearchIcon,
        CloseIcon: CloseIcon,
        CoveoAILoggedIn: CoveoAILoggedIn
    },
    computed: {
        placeholderText() {
            return this.altPlaceholderText ? Granite.I18n.get(this.altPlaceholderText) : Granite.I18n.get('what.are.you.looking.for')
        },
        searchLabel() {
            return Granite.I18n.get('button.search.Title')
        },
        pageName() {
            return store.state.page.pageInfo.pageName
        },
        state() {
            this.count
            return this.searchBoxController?.state
        },
        suggestionClass() {
            if (
                this.pageName == 'technical-content' &&
                window.innerWidth > 767 &&
                this.controllerVar == 'inPageController'
            ) {
                return 'suggestion_list_tech_content'
            } else if (
                this.pageName == 'events' &&
                window.innerWidth > 767 &&
                this.controllerVar == 'inPageController'
            ) {
                return 'suggestion_list_events'
            } else {
                return ''
            }
        },
        controllerVar() {
            var controllerVar = null
            if (this.$el.parentElement.id == 'inPage-search-container') {
                controllerVar = 'inPageController'
            } else {
                controllerVar = 'globalController'
            }
            return controllerVar
        },
        searchEngine() {
            return this.$store.state.search.engines[this.engineKey]?.engine || this.corporateEngine
        },
        getSearchPageUrl() {
            return window.headlessSearchPageEnabled ? 'headless-search.html' : 'search.html'
        }
    },
    methods: {
        submit(e, suggestion) {
            this.synchronizeAnalyticsConsent()

            if (suggestion) {
                this.q = suggestion
            } else if (this.suggestionIndex != -1) {
                this.q = this.state.suggestions[this.suggestionIndex].rawValue
            }

            this.selectedSearchValue = this.q
        },
        selectSuggestion(e) {
            if (e.which === 40) {
                if (this.suggestionIndex != -1) {
                    var previousEl = document.getElementById(
                        'suggestion' + this.suggestionIndex
                    )
                    if (previousEl != null) {
                        previousEl.classList.remove('suggestionHover')
                        this.suggestionIndex++
                    }
                } else {
                    this.suggestionIndex++
                }
                var el = document.getElementById(
                    'suggestion' + this.suggestionIndex
                )
                if (el != null && this.state.suggestions[this.suggestionIndex]) {
                    el.classList.add('suggestionHover')
                } else if (this.state.suggestions.length - 1 < this.suggestionIndex) {
                    this.suggestionIndex = 0
                    el = document.getElementById(
                        'suggestion' + this.suggestionIndex
                    )
                    el.classList.add('suggestionHover')
                }
            } else if (e.which === 38) {
                if (this.suggestionIndex != -1) {
                    var previousEl = document.getElementById(
                        'suggestion' + this.suggestionIndex
                    )
                    if (previousEl != null) {
                        previousEl.classList.remove('suggestionHover')
                        this.suggestionIndex--
                    }
                }
                var el = document.getElementById(
                    'suggestion' + this.suggestionIndex
                )
                if (el != null && this.suggestionIndex != -1) {
                    el.classList.add('suggestionHover')
                } else if (this.suggestionIndex == -1) {
                    this.suggestionIndex = this.state.suggestions.length - 1
                    el = document.getElementById(
                        'suggestion' + this.suggestionIndex
                    )
                    el.classList.add('suggestionHover')
                }
            }
        },
        updateText(q) {
            if (this.searchBoxController) {
                this.searchBoxController.updateText(q)
            }
        },
        displaySuggestions() {
            this.synchronizeAnalyticsConsent()
            this.showSuggestions = true
            if (this.searchBoxController) {
                this.searchBoxController.showSuggestions()
            }
        },
        synchronizeAnalyticsConsent() {
            applyConsentToHeadlessEngine(this.searchEngine)
            window.dowConsent?.updateCoveoAnalytics?.()
        },
        hideSuggestions() {
            setTimeout(() => {
                this.suggestionIndex = -1
                this.showSuggestions = false
            }, 300)
        },
        clearSearchTerm() {
            this.q = ''
            this.searchBoxController.clear()
        },
        closeAnyModal() {
            document.querySelectorAll('.cmp-mega-menu.cmp-mega-menu--active-level-0')
                .forEach(menu => menu.classList.remove('cmp-mega-menu--active-level-0'))
            document.querySelectorAll('.cmp-mega-menu-navigation__nav-buttons-text.nav-buttons-text--active')
                .forEach(link => link.classList.remove('nav-buttons-text--active'))
            document.querySelectorAll('.cmp--header .cmp--header_language-modal')
                .forEach(modal => modal.style.display = 'none')
            document.querySelectorAll('.cmp--header .cmp--header_language-selector svg.cmp--header_icon-arrow-sm')
                .forEach(icon => icon.style.transform = 'rotate(-90deg)')
            document.querySelectorAll('.cmp--header .cmp--header_my-account-modal')
                .forEach(modal => modal.removeAttribute('style'))
            document.querySelectorAll('.cmp--header_my-account')
                .forEach(link => link.dispatchEvent(new Event('click')))
            document.querySelectorAll('.cmp-mega-menu-navigation__nav.cmp-mega-menu-navigation__nav-open')
                .forEach(nav => nav.classList.remove('cmp-mega-menu-navigation__nav-open'))
            document.querySelectorAll('.cmp-mega-menu-navigation-hamburger.cmp-mega-menu-navigation-hamburger--open')
                .forEach(hamburger => hamburger.classList.remove('cmp-mega-menu-navigation-hamburger--open'))

        },
        initializeTabController() {
            this.allTabController = buildTab(this.searchEngine, {
                options: {
                    id: 'All',
                    expression: ''
                },
                initialState: {
                    isActive: true
                }
            })
        }
    },
    watch: {
        searchEngine: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    if (!this.searchBoxController) {
                        this.initializeTabController()

                        const protocol = window.location.protocol
                        const hostname = window.location.hostname
                        const locale = store.state.browser.languageCode
                        const searchPageUrl = window.headlessSearchPageEnabled ? 'headless-search.html' : 'search.html'
                        const redirectionUrl = `${protocol}//${hostname}/${locale}/${searchPageUrl}`

                        this.searchBoxController = buildStandaloneSearchBox(
                            this.searchEngine,
                            {
                                options: {
                                    clearFilters: false,
                                    highlightOptions: {
                                        exactMatchDelimiters: {
                                            open: '<span class="highlight">',
                                            close: '</span>'
                                        }
                                    },
                                    enableQuerySyntax: true,
                                    redirectionUrl: redirectionUrl
                                }
                            }
                        )
                        this.searchBoxController.subscribe(() => {
                            this.count++

                            if (!this.corporateEngine) {
                                const isLoading = this.searchBoxController.state?.isLoading

                                if (this.searchBoxController.state?.redirectTo && !isLoading) {
                                    let redirectUrl = this.searchBoxController.state.redirectTo
                                    let encodedSelectedSearchValue = encodeURIComponent(this.selectedSearchValue)

                                    const parsed = new URL(redirectUrl, window.location.href)
                                    let redirectIsToSearchPage = parsed.pathname.includes(this.getSearchPageUrl)

                                    if (redirectIsToSearchPage && this.selectedSearchValue) {
                                        window.location.href = redirectUrl + '&q=' + encodedSelectedSearchValue
                                    } else {
                                        window.location.href = redirectUrl
                                    }

                                    window.dispatchEvent(new CustomEvent('coveo-search-update-analytics', {
                                        detail: { query: this.selectedSearchValue }
                                    }))
                                    this.searchBoxController.afterRedirection()
                                }
                            }
                        })
                    }
                }
            }
        },
        q(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.updateText(this.q)
            }
        },
        selectedSearchValue(oldVal, newVal) {
            this.authorableAemFields = this.parentAuthorableElementId
                ? document.querySelector(this.parentAuthorableElementId)
                : null
            var languageCode = store.state.browser.languageCode
            var searchPageUrl = this.getSearchPageUrl
            var searchUrl =
                this.authorableAemFields !== null
                    ? this.authorableAemFields.dataset.searchUrl
                    : searchPageUrl

            var searchQueryParam = this.corporateEngine ? 't=All' : '#tab=All'
            if (this.activeTab) {
                searchQueryParam = this.activeTab
            } else if (this.authorableAemFields !== null) {
                searchQueryParam = this.authorableAemFields.dataset.searchQueryParam
            }

            var url = '/' + languageCode + '/' + searchUrl + searchQueryParam

            if (this.corporateEngine) {
                let encodedSelectedSearchValue = encodeURIComponent(this.selectedSearchValue)
                window.location.href = encodedSelectedSearchValue
                    ? url + '&q=' + encodedSelectedSearchValue
                    : url

                if (this.selectedSearchValue.toLowerCase() === 'jobs' || this.selectedSearchValue.toLowerCase() === 'careers') {
                    window.location.replace("https://corporate.dow.com/en-us/careers.html")
                }
                if (this.selectedSearchValue.toLowerCase() === 'retire' || this.selectedSearchValue.toLowerCase() === 'retirement') {
                    window.location.replace("https://corporate.dow.com/en-us/benefits/retiree-and-alumni.html")
                }
            } else {
                this.searchBoxController.updateRedirectUrl(url)
                this.searchBoxController.submit()
            }

            this.closeAnyModal()
        }
    },
    created() {
        this.authorableAemFields = this.parentAuthorableElementId
            ? document.querySelector(this.parentAuthorableElementId)
            : null
        const searchHub = this.authorableAemFields?.dataset.searchHub || this.engineKey

        if (searchHub !== this.engineKey) {
            var params = {
                hub: searchHub,
                customFilter: null
            }
            store.dispatch('search/fetchSearchToken', params).then((result) => {
                if (result === -1) {
                    console.log(
                        'Error during building Coveo search engine: Failed to fetch search token'
                    )
                } else {
                    const search = {
                        searchHub: params.hub
                    }
                    this.corporateEngine = buildSearchEngine({
                        configuration: {
                            organizationId: result.data.org,
                            accessToken: result.data.token,
                            search: search,
                            analytics: headlessAnalyticsConfig()
                        },
                        navigatorContextProvider: consentNavigatorContextProvider()
                    })
                    applyConsentToHeadlessEngine(this.corporateEngine)
                }
            })
        } else {
            this.$store.dispatch('search/getEngine', { hub: searchHub, showAll: false })
        }
    },
    deactivated() {
        this.searchBoxController = null
    }
}

export default SearchBox
